import $ from 'jquery';
import Swiper from 'swiper';

export function initSwiper(swiperElements) {
    // loop over swiper instances and init them
    swiperElements.forEach((swiper) => {
        let swiperInstance = null,
            destroyOn = swiper.dataset.destroyOn,
            height = swiper.dataset.height || undefined,
            centeredSlides = swiper.dataset.centeredSlides === true,
            slidesPerView = swiper.dataset.slidesPerView || 'auto',
            autoplay = swiper.dataset.autoplay,
            cssMode = swiper.dataset.cssMode || false,
            parentNode = swiper.parentNode.parentNode.parentNode,
            prevEl = parentNode.querySelector('.swiper-button-prev'),
            nextEl = parentNode.querySelector('.swiper-button-next'),
            createSwiper = () => {
                if (autoplay && isNaN(autoplay) === false) {
                    autoplay = {
                        delay: Number(autoplay),
                    };
                } else {
                    autoplay = autoplay === 'true' ? { delay: 3000 } : false;
                }

                swiperInstance = new Swiper(swiper, {
                    init: false,
                    touchStartPreventDefault: false,
                    loop: swiper.dataset.loop === 'true',
                    autoHeight: height === 'auto',
                    height: !isNaN(height) ? Number(height) : undefined,
                    centeredSlides,
                    slidesPerView: !isNaN(slidesPerView) ? Number(slidesPerView) : slidesPerView,
                    autoplay,
                    cssMode,
                    // 1 to prevent render issues where the next slide is shown too early
                    spaceBetween: Number(swiper.dataset.spaceBetween || 1),

                    navigation: {
                        nextEl,
                        prevEl,
                    },

                    pagination: {
                        el: swiper.parentNode.parentNode.parentNode.querySelectorAll('.swiper-pagination'),
                        clickable: true,
                        type: 'custom',
                        renderCustom(swiper, current, total) {
                            if (total <= 1) {
                                return '';
                            }

                            let className = 'swiper-pagination-bullet',
                                html = '';

                            for (let i = 1; i <= total; i++) {
                                if (i === current) {
                                    html += `<button type="button" class="${className} ${className}-active" title="Current slide (${i})" disabled aria-hidden=true></button>`;
                                } else {
                                    html += `<button type="button" class="${className}" title="Go to slide ${i}" aria-hidden="true"></button>`;
                                }
                            }

                            return html;
                        },
                    },

                    a11y: {
                        enabled: false, // implementation is not ideal, do it manually
                    },

                    on: {
                        init() {
                            if (swiperInstance.params.loop) {
                                swiperInstance.slides.each((i, slide) => {
                                    if (slide.classList.contains(swiperInstance.params.slideDuplicateClass)) {
                                        slide.setAttribute('aria-hidden', 'true');
                                    }
                                });
                            }

                            prevEl.disabled = swiperInstance.isBeginning;
                            nextEl.disabled = swiperInstance.isEnd;
                        },
                        reachBeginning() {
                            if (swiperInstance.params.loop !== true) {
                                prevEl.disabled = true;
                            }
                        },
                        reachEnd() {
                            if (swiperInstance.params.loop !== true) {
                                nextEl.disabled = true;
                            }
                        },
                        fromEdge() {
                            prevEl.disabled = false;
                            nextEl.disabled = false;
                        },
                    },
                });

                swiperInstance.init();
            },
            resizeCallback = () => {
                // destroy swiper after a given breakpoint
                if (Foundation.MediaQuery.atLeast(destroyOn)) {
                    swiper.parentElement.classList.add('swiper--destroyed');

                    if (swiperInstance !== null) {
                        swiperInstance.destroy(true, true);
                        swiperInstance = null;
                    }
                } else if (swiperInstance === null) {
                    swiper.parentElement.classList.remove('swiper--destroyed');

                    createSwiper();
                }
            };

        if (destroyOn) {
            $(window).on('changed.zf.mediaquery', resizeCallback); // it is not possible to listen for jQuery events in vanilla JS

            resizeCallback();
        } else {
            createSwiper();
        }
    });
}
